var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepartmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "21px",
    viewBox: "0 0 19 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "08922B39-92E1-4FDE-B6B3-9F01DD380BD1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-Accounts-Health-System-Info-Copy-14",
    transform: "translate(-502.000000, -279.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(502.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2,4.7 L1.2,19.2 L0.6,19.2 C0.3,19.2 0,19.5 0,19.8 C0,20.1 0.3,20.4 0.6,20.4 L17.7,20.4 C18,20.4 18.3,20.1 18.3,19.8 C18.3,19.5 18,19.2 17.7,19.2 L17.1,19.2 L17.1,4.7 C17.1,4.4 16.8,4.1 16.5,4.1 L13.2,4.1 C13.2,4.1 13.2,4 13.2,4 C13.2,1.8 11.4,0 9.2,0 C7,0 5.2,1.8 5.2,4 C5.2,4 5.2,4.1 5.2,4.1 L1.8,4.1 C1.5,4.1 1.2,4.4 1.2,4.7 L1.2,4.7 Z M6.4,19.2 L6.4,15.3 L8.6,15.3 L8.6,19.2 L6.4,19.2 Z M9.7,19.2 L9.7,15.3 L11.9,15.3 L11.9,19.2 L9.7,19.2 Z M9.1,1.1 C10.7,1.1 12,2.4 12,4 C12,5.6 10.7,6.9 9.1,6.9 C7.5,6.9 6.2,5.6 6.2,4 C6.2,2.4 7.5,1.1 9.1,1.1 Z M2.3,5.3 L5.2,5.3 C5.7,6.9 7.2,8.1 9,8.1 C10.8,8.1 12.3,6.9 12.8,5.3 L15.7,5.3 L15.7,19.3 L12.8,19.3 L12.8,14.8 C12.8,14.5 12.5,14.2 12.2,14.2 L5.8,14.2 C5.5,14.2 5.2,14.5 5.2,14.8 L5.2,19.3 L2.3,19.3 L2.3,5.3 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,12.8 C14.4,12.8 14.7,12.5 14.7,12.2 L14.7,9.5 C14.7,9.2 14.4,8.9 14.1,8.9 L4.2,8.9 C3.9,8.9 3.6,9.2 3.6,9.5 L3.6,12.2 C3.6,12.5 3.9,12.8 4.2,12.8 L14.1,12.8 L14.1,12.8 Z M8,11.7 L8,10.1 L10.3,10.1 L10.3,11.7 L8,11.7 Z M13.5,11.7 L11.4,11.7 L11.4,10.1 L13.5,10.1 L13.5,11.7 Z M4.7,10.1 L6.8,10.1 L6.8,11.7 L4.7,11.7 L4.7,10.1 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6,4.6 L8.6,4.6 L8.6,5.6 C8.6,5.9 8.9,6.2 9.2,6.2 C9.5,6.2 9.8,5.9 9.8,5.6 L9.8,4.6 L10.8,4.6 C11.1,4.6 11.4,4.3 11.4,4 C11.4,3.7 11.1,3.4 10.8,3.4 L9.8,3.4 L9.8,2.4 C9.8,2.1 9.5,1.8 9.2,1.8 C8.9,1.8 8.6,2.1 8.6,2.4 L8.6,3.4 L7.6,3.4 C7.3,3.4 7,3.7 7,4 C7,4.4 7.3,4.6 7.6,4.6 L7.6,4.6 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentIcon);
export default __webpack_public_path__ + "static/media/department-icon.5f65b85a7116ca3b0d93f5dbc588894c.svg";
export { ForwardRef as ReactComponent };